import { create } from "zustand";
import { CategoryInterface } from "../constants/Category";
import { axiosPublic } from "../utils/AxiosInstance";

interface CategoryStoreInterface {
  data: CategoryInterface[] | undefined;
  isLoading: boolean;
  error: string | null;
  fetchCategory: () => Promise<void>;
}

export const useFetchCategory = create<CategoryStoreInterface>((set) => ({
  data: undefined,
  isLoading: false,
  error: null,
  fetchCategory: async () => {
    set({ isLoading: true, error: null });

    try {
      const response = await axiosPublic.get(`/v1/masterdata/category`);
      set({ data: response.data.data });
    } catch (error: any) {
      set({ error: error?.response?.data?.message });
    } finally {
      set({ isLoading: false });
    }
  },
}));
